//src/common/components/unitdiagrams.js
import global, { SPARE_AXLE } from "../../../../shared/utils/global.js";
import { addLeadingZero } from "../../../../shared/utils/general.js";

export const createTyreNameElement = (axle, tyre) => {

  let sensorNameDiv = document.createElement('div');
  sensorNameDiv.className = "axletyresensor";
  if (axle === "S")
    sensorNameDiv.innerHTML = "Spare " + tyre;
  else
    sensorNameDiv.innerHTML = "A" + axle + "-T" + tyre;

  return sensorNameDiv;
};


export const createAxleElement = () => {

  const axleDiv = document.createElement('div');
  const axleSvg = document.createElement('svg');
  axleSvg.className = 'shortaxle';

  axleDiv.appendChild(axleSvg);

  return axleDiv;
};

export const getAxleActiveStatus = (axleRanges, axleNoUnitNo) => {

  if (axleRanges) {
    const axle = axleRanges.find(axle => axle.axleNumber === axleNoUnitNo);
    if (!axle) {
      return false;
    }

    return (
      axle.recommendedPressure > 0 ||
      axle.pressureDeviationAllowedLow > 0 ||
      axle.pressureDeviationAllowedHigh > 0 ||
      axle.minPressure > 0 ||
      axle.maxPressure > 0 ||
      axle.maxTemperature > 0 ||
      axle.minVoltage > 0
    );
  } else { return false; }
};


export const createTyreIdElement = (tyreArrayIndex, axleSensors) => {

  let tyreId = document.createElement('div');
  tyreId.className = 'tyreid';
  tyreId.innerText = axleSensors[tyreArrayIndex].tyreId;

  return tyreId;
};

export const createSensorIdElement = (sensorId) => {

  let sensorIdDiv = document.createElement('div');
  sensorIdDiv.className = 'sensorid';
  sensorIdDiv.innerHTML = sensorId;

  return sensorIdDiv;
};

export const createSensorPressureElement = (tyreArrayIndex, axleSensors) => {

  let sensorPressureDiv = document.createElement('div');
  let sensorvaluesdivclasses = ['sensorvalues'];

  if (axleSensors[tyreArrayIndex].pressureLabelColour != 'green')
    sensorvaluesdivclasses = ['sensorvalues', `pt-${axleSensors[tyreArrayIndex].pressureLabelColour}`];

  sensorPressureDiv.classList.add(...sensorvaluesdivclasses);

  let pressure = axleSensors[tyreArrayIndex].currentPressure;
  sensorPressureDiv.innerHTML = pressure + " bar";
  return sensorPressureDiv;
};

export const createSensorTemperatureElement = (tyreArrayIndex, axleSensors) => {

  let sensorTemperatureDiv = document.createElement('div');
  let sensorvaluesdivclasses = ['sensorvalues'];
  if (axleSensors[tyreArrayIndex].temperatureLabelColour != 'green')
    sensorvaluesdivclasses = ['sensorvalues', `pt-${axleSensors[tyreArrayIndex].temperatureLabelColour}`];

  let temperature = axleSensors[tyreArrayIndex].temperatureValue;

  sensorTemperatureDiv.classList.add(...sensorvaluesdivclasses);
  sensorTemperatureDiv.innerHTML = temperature + " &#x2103";

  return sensorTemperatureDiv;
};

export const createSensorVoltageElement = (tyreArrayIndex, axleSensors) => {

  let sensorVoltageDiv = document.createElement('div');
  let sensorvaluesdivclasses = ['sensorvalues'];
  if (axleSensors[tyreArrayIndex].voltageLabelColour != 'green')
    sensorvaluesdivclasses = ['sensorvalues', `pt-${axleSensors[tyreArrayIndex].voltageLabelColour}`];

  let voltage = axleSensors[tyreArrayIndex].voltageValue;

  sensorVoltageDiv.classList.add(...sensorvaluesdivclasses);
  sensorVoltageDiv.innerHTML = voltage + " V";

  return sensorVoltageDiv;
};

export const createSensorNoSignalElement = () => {

  let sensorNoSignalDiv = document.createElement('div');

  sensorNoSignalDiv.classList.add(...sensorvaluesdivclasses);
  sensorNoSignalDiv.innerText = "No Signal";

  return sensorNoSignalDiv;
};

export const createTrailerHeader = (diagram, unitSensors, trailerName) => {

  const trailerHeader = document.createElement('div');

  const header = document.createElement('h6');
  const headerLabel = document.createElement('div');

  const linkIcon = document.createElement('svg');
  linkIcon.className = 'linkicon';
  const headerText = document.createElement('span');

  headerLabel.appendChild(linkIcon);
  headerLabel.appendChild(headerText);

  // if (diagram === 'sv' || diagram === 'r') {
  trailerHeader.className = 'unitbox';
  headerText.id = `${diagram}trailer${trailerName}`;
  headerText.innerText = `Trailer ${trailerName}`;


  header.appendChild(headerLabel);
  trailerHeader.appendChild(header);

  return trailerHeader;
};





